import React from 'react';
import { useSelector } from "react-redux";
import { Redirect, Route, Switch, useHistory } from "react-router-dom";
import AddOn from "./AddOn";
import AddOnList from "./AddOnList";

function AddOnHandler() {
    const history = useHistory();
    const businessId = useSelector((state) => { return (state.buisnessDetails.businessId) })
    return(
        <React.Fragment>
            <Switch>
            <Route path = {`/dashboard/${businessId}/Add-Ons`} exact render = {() => {return(<AddOnList />)}} />
            <Route path = {`/dashboard/${businessId}/Add-Ons/:addOnIdURL`} render = {() => {return(<AddOn />);}} />
            <Route path='*' render={() => { return (<Redirect to='/404' />) }} />
            </Switch>
        </React.Fragment>
    );
};

export default AddOnHandler;